
import { settingsRequest } from '@/helpers/RequestHelpers';
import apiURL from './apiURL';
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
  GRADE_APPLY_MODAL: "GRADE_APPLY_MODAL",
  GRADE_OPEN_MODAL: "GRADE_OPEN_MODAL",
  // GRADE_UPDATE_CURRENT_TIMESHEET: "GRADE_UPDATE_CURRENT_TIMESHEET"
  GRADE_SAVE_CURRENT_TIMESHEET: "GRADE_SAVE_CURRENT_TIMESHEET",
  GRADE_SAVING_CURRENT_TIMESHEET: "GRADE_SAVING_CURRENT_TIMESHEET",
  GRADE_UPDATE_LIST: "GRADE_UPDATE_LIST",
};

// actions
const gradeSetApplyModal = (status) => ({
  type: Types.GRADE_APPLY_MODAL,
  status: status,
});

// actions
const gradeSetOpenModal = (status,grade) => ({
  type: Types.GRADE_OPEN_MODAL,
  status: status,
  grade: grade,
});

const gradeUpdateSaveStatus = response => ({
  type: Types.GRADE_SAVE_CURRENT_TIMESHEET,
  payload: response
});

const gradeSave = (grade) => {
  return (dispatch, getState) => {

    fetch(apiURL + `/settings/grade/` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(grade),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(gradeUpdateSaveStatus(data))
      dispatch(gradesGetList())
    })
  }
}

const gradesUpdateList = response => ({
  type: Types.GRADE_UPDATE_LIST,
  payload: response
});

const gradesGetList = () => {
  return (dispatch, getState) => {

    settingsRequest({
      method: 'GET',
      path: "/grades"
    })
    .then(({data}) => {
      console.log('entity data',data)
      dispatch(gradesUpdateList(data))
    })
  }
}

/*const selectTrackingCategory = trackingCategory => ({
  type: Types.SELECT_TRACKING_CATEGORY,
  trackingCategory: trackingCategory
});

const selectYear = year => ({
  type: Types.SELECT_YEAR,
  year
});

const updateFacilities = response => ({
  type: Types.GET_FACILITIES,
  payload: response
});

const getFacilities = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/my/facilities` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Organisation': getState().currentOrganisation,
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(updateFacilities(data))
    })
  }
}*/

const Actions = {
  gradeSetApplyModal,
  gradeSetOpenModal,
  gradeSave,
  gradeUpdateSaveStatus,
  gradesGetList,
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions